import React from "react";
import { connect } from "react-redux";
import { logoutRequest } from "../../../redux/auth/authState";
import Button from "components/button";
import { displayIcon } from "variables/icons";

const PanelLogout = ({logout, ...props}) => {

  const handleLogout = (e) => {
	  e.preventDefault();
	  logout();
  };

  return (
    <>
      <div className="flex justify-center px-6 py-9">
        <button onClick={handleLogout}
          type="button"
          className="flex items-center gap-3 rounded-xl bg-green-700 px-10 py-4 text-base font-medium text-white shadow-sm transition hover:bg-green-800"
        >
          {displayIcon("LogOut")}
          Logout
        </button>
      </div>

      <footer className="bg-green-800 text-white">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 py-6 md:flex-row">
          <div className="flex items-center gap-5">
            <a href="#" aria-label="Facebook">
              {displayIcon("Facebook")}
            </a>

            <a href="#" aria-label="YouTube">
              {displayIcon("Youtube")}
            </a>

            <a href="#" aria-label="Website">
              {displayIcon("Globe")}
            </a>
          </div>

          <p className="text-center text-sm leading-5 text-green-100">
            © 2025 Department of Agriculture
            <br />
            Digital Agriculture Philippines
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-green-100">
            <a href="#" className="hover:text-white">
              Privacy Policy
            </a>

            <span className="opacity-50">|</span>

            <a href="#" className="hover:text-white">
              Terms of Use
            </a>

            <span className="opacity-50">|</span>

            <a href="#" className="hover:text-white">
              Help Center
            </a>
          </div>
        </div>
      </footer>
    </>
    // <div className="flex h-full w-full bg-lightPrimary dark:!bg-intsamis-900 justify-center px-2 pt-4">
    //   <Button onClick={handleLogout}>Logout</Button>
    // </div>
  );
};

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logoutRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelLogout);
